import { handleFormSubmit } from './js-components/contact-form';

handleFormSubmit();
